import Box from '@mui/material/Box';
import Navigation from './Navigation';
import SidebarLogout from './SidebarLogout';

const hideScrollbarSx = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { width: 0, height: 0, display: 'none' }
};

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#ffffff',
        overflow: 'hidden',
        maxWidth: '100%',
        ...hideScrollbarSx
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          ...hideScrollbarSx
        }}
      >
        <Navigation />
      </Box>
      <SidebarLogout />
    </Box>
  );
}
